module.exports = __webpack_public_path__ + "static/media/john.b2824f70.png";